import angular from 'angular';
import template from './jobSummariesView.html';

export class JobSummariesComponent {
    /* @ngInject */
    constructor() {
        const jobSummariesCtrl = this;
        jobSummariesCtrl.init = function () {

        };

        jobSummariesCtrl.init();
    }
}

export const JobSummariesComponentConfiguration = {
    template,
    controller: JobSummariesComponent,
    controllerAs: 'jobSummariesCtrl',
};

angular
    .module('TALENYA-FE')
    .component('jobSummariesComponent', JobSummariesComponentConfiguration);
